/** Wspólne stany interfejsu Premium; konfiguracje i opcje wtyczek pochodzą z API. */
import contract from "./apiContract.json";

export const OrderStatus = Object.freeze(contract.orderStatus);
export const statusLabels = Object.freeze({
  [OrderStatus.QUEUED]: "Odczytywanie dokumentów",
  [OrderStatus.REVIEW]: "Sprawdź świadectwo",
  [OrderStatus.APPROVED]: "Przygotowanie do wystawienia",
  [OrderStatus.ISSUING]: "Wystawianie",
  [OrderStatus.ISSUED]: "Wystawiono",
  [OrderStatus.READ_FAILED]: "Błąd odczytu",
  [OrderStatus.ISSUE_FAILED]: "Błąd wystawienia",
});
export const PROCESSING_STATUSES = Object.freeze([
  OrderStatus.QUEUED,
  OrderStatus.APPROVED,
  OrderStatus.ISSUING,
]);
export const SettingType = Object.freeze(contract.settingType);
export const DictionaryType = Object.freeze(contract.dictionaryType);
export const DictionaryFieldType = Object.freeze(contract.dictionaryFieldType);
export const RECIPIENT_FIELDS = Object.freeze(contract.recipientFields);
const EventKind = Object.freeze(contract.eventKind);
export const ORDER_POLL_MS = 3500;

export const processingDescriptions = Object.freeze({
  [OrderStatus.QUEUED]:
    "Przygotowujemy dane z dodanych dokumentów. Następnie będzie można je sprawdzić i poprawić.",
  [OrderStatus.APPROVED]:
    "Przygotowujemy numer i zatwierdzone dane świadectwa.",
  [OrderStatus.ISSUING]: "Tworzymy i podpisujemy plik PDF świadectwa.",
});

export const PreviewKind = Object.freeze({
  DRAFT: "draft",
  SOURCE: "source",
  CERTIFICATE: "certificate",
});

export const isProcessing = (status) => PROCESSING_STATUSES.includes(status);
export const eventLabels = Object.freeze({
  [EventKind.CREATED]: "Dodano dokumenty",
  [EventKind.READ]: "Odczytano dokumenty",
  [EventKind.CORRECTED]: "Zapisano korekty",
  [EventKind.APPROVED]: "Zatwierdzono",
  [EventKind.RESERVED]: "Przydzielono numer",
  [EventKind.ISSUED]: "Wystawiono",
  [EventKind.FAILED]: "Błąd przetwarzania",
  [EventKind.RETRIED]: "Ponowiono",
});
